export default { CARD: 'card' };
